import { registerLocaleData } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import localeEsAr from "@angular/common/locales/es-AR";
import localeEsArExtra from "@angular/common/locales/extra/es-AR";
import { Injectable, LOCALE_ID, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatIconRegistry } from "@angular/material/icon";
import {
    BrowserModule,
    DomSanitizer,
    HAMMER_GESTURE_CONFIG,
    HammerGestureConfig,
    HammerModule
} from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxsModule } from "@ngxs/store";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NotifierModule } from "@nahuelmorata/angular-notifier";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { UiSwitchModule } from "ngx-ui-switch";

import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core";
import { HttpClientExtended } from "@shared";
import { providers } from "@shared/providers";
import { GlobalState, PaisesState } from "@shared/states";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import Hammer from "hammerjs";

registerLocaleData(localeEsAr, "es-AR", localeEsArExtra);

@Injectable()
export class LivepanelHammerConfig extends HammerGestureConfig {
    overrides = {
        swipe: {
            direction: Hammer.DIRECTION_ALL
        }
    };
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ReactiveFormsModule,
        HttpClientModule,
        HammerModule,
        NgbModule,
        BsDropdownModule.forRoot(),
        NgSelectModule,
        UiSwitchModule.forRoot({
            size: "small"
        }),
        ServiceWorkerModule.register("ngsw-worker.js", { enabled: environment.production || environment.staging }),
        CoreModule,
        NgxChartsModule,
        NgxsModule.forRoot([GlobalState, PaisesState], { developmentMode: !environment.production }),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        NotifierModule.withConfig({
            position: {
                horizontal: {
                    position: "right"
                },
                vertical: {
                    position: "top"
                }
            }
        })
    ],
    providers: [
        { provide: HttpClient, useClass: HttpClientExtended },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: LivepanelHammerConfig
        },
        { provide: LOCALE_ID, useValue: "es-AR" },
        ...providers
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
        matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl("./assets/mdi.svg"));
    }
}
